/* eslint-disable */

import * as runtime from '../runtime';
import type {
  CreateSpotHoldDto,
  ResultDto,
  SpotHoldResponseDto,
} from '../models';

export interface CreateHoldRequest {
  orgId: number;
  createSpotHoldDto: CreateSpotHoldDto;
}

export interface ReleaseHoldRequest {
  orgId: number;
  id: string;
}

export class SpotHoldsApi extends runtime.BaseAPI {

  async createHold(requestParameters: CreateHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SpotHoldResponseDto> {
    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    const response = await this.request({
      path: `/spot-holds/org/${encodeURIComponent(String(requestParameters.orgId))}/spot-holds`,
      method: 'POST',
      headers: headerParameters,
      query: {},
      body: requestParameters.createSpotHoldDto,
    }, initOverrides);
    return response.json();
  }

  async releaseHold(requestParameters: ReleaseHoldRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultDto> {
    const response = await this.request({ path: `/spot-holds/org/${encodeURIComponent(String(requestParameters.orgId))}/spot-holds/${encodeURIComponent(String(requestParameters.id))}`, method: 'DELETE', headers: {}, query: {} }, initOverrides);
    return response.json();
  }

}
